module.exports = __webpack_public_path__ + "media/honey-icons/icon-smoke-a284e7cb.svg";